import { Spin } from 'antd';
import { useApiRequests } from '@presentation/hooks/useApiRequests';
import { useFolders } from '@presentation/hooks/useFolders';
import { RequestTreeNode } from '@presentation/components/workbench/RequestTreeNode';
import { FolderTreeNode } from '@presentation/components/workbench/FolderTreeNode';

interface FolderTreeLevelProps {
  workspaceId: string;
  collectionId: string;
  parentId: string | null;
  depth: number;
}

export const FolderTreeLevel = ({
  workspaceId,
  collectionId,
  parentId,
  depth,
}: FolderTreeLevelProps) => {
  const { data: folders, isLoading: foldersLoading } = useFolders(collectionId, parentId);
  const { data: requests, isLoading: requestsLoading } = useApiRequests(collectionId, parentId);

  if (foldersLoading || requestsLoading) {
    return (
      <div className="py-2 pl-8">
        <Spin size="small" />
      </div>
    );
  }

  if ((folders?.length ?? 0) === 0 && (requests?.length ?? 0) === 0) {
    return <div className="py-1 pl-8 text-xs text-gray-400">Empty</div>;
  }

  return (
    <div style={{ paddingLeft: depth > 1 ? 12 : 0 }}>
      {folders?.map((folder) => (
        <FolderTreeNode key={folder.id} workspaceId={workspaceId} folder={folder} depth={depth} />
      ))}
      {requests?.map((request) => (
        <RequestTreeNode key={request.id} workspaceId={workspaceId} request={request} />
      ))}
    </div>
  );
};
